import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getDashboardGeralPublico } from "./services";
import { TResponseDashboardGeral } from "../../../dashboard-geral/types";

const initialState: { status: string; data: TResponseDashboardGeral | null } = {
  status: "",
  data: null,
};

export const actionGetDashboardGeralPublico = createAsyncThunk<
  TResponseDashboardGeral,
  string
>("ACTION_GET_DASHBOARD_GERAL_PUBLICO", async (apiKey: string) => {
  const result = await getDashboardGeralPublico(apiKey);
  console.log("DashboardGeral fetched", result);
  return result;
});

const sliceAlertas = createSlice({
  name: "GET_DASHBOARD_GERAL_PUBLICO",
  initialState,
  reducers: {
    actionResetAlertas: (state) => {
      state.status = "idle";
      state.data = null;
    },
  },
  extraReducers: {
    [`${actionGetDashboardGeralPublico.pending}`]: (state) => {
      state.status = "loading";
    },
    [`${actionGetDashboardGeralPublico.fulfilled}`]: (
      state,
      action: PayloadAction<TResponseDashboardGeral>,
    ) => {
      state.status = "success";
      state.data = action.payload;
    },
    [`${actionGetDashboardGeralPublico.rejected}`]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceAlertas.reducer;
export const { actionResetAlertas } = sliceAlertas.actions;
